import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class ValidHazmatEndorsementAvailability extends _BaseUserProfile {
  component = 'YesNoSelection';
  props = {
    title: 'Do You Have a Valid Hazmat Endorsement?',
    errorMessage: 'Please Answer on Question',
  };
}
